import React from 'react'
import "../styles/about.css"

const About = () => {
    return (
        <section className='about' id='about'>
            <div className="title__container">
                <h1 className="title__about">Про подію</h1>
            </div>
            <div className="content__container">
                <div className="txt__container__first">
                    <p className='p__about'>
                        На <span> Lviv AI Community 2025: AI made in Ukraine </span> виступатимуть провідні фахівці зі штучного інтелекту, які поділяться практичними знаннями та надихаючими ідеями щодо майбутнього технологій, освіти та кар'єри. Це буде насичений день, що відкриє нові перспективи для студентів, молодих спеціалістів і всіх, хто прагне розвиватися в AI.
                        <br />
                        <br />
                        Приєднуйтесь до <span> Lviv AI Community 2025: AI made in Ukraine, </span> щоб дізнатися про нові можливості для навчання, кар’єри та розвитку в AI. Подія стане чудовою нагодою для обміну досвідом, надихаючих дискусій та встановлення нових зв'язків!
                    </p>
                </div>
                <div className="txt__container">
                    <h3 className="list__title">Ви довідаєтеся про:</h3>
                    <ul>
                        <li>Поточний стан українських LLM та перспективи їх розвитку — ключові досягнення, виклики локалізації та можливості масштабування українських мовних моделей.</li>
                        <li>Поєднання академічного ML з реальними викликами робототехніки — як наукові підходи працюють у практичних інженерних системах та з якими труднощами стикаються команди.</li>
                        <li>AI як інструмент покращення навчальних процесів та інтеграції практичного досвіду — застосування ШІ в освіті, персоналізація навчання та впровадження прикладних кейсів.</li>
                        <li>Інвестиційна привабливість AI-проєктів та шлях від ідеї до реалізації — на що звертають увагу інвестори, типові помилки та фактори успіху.</li>
                        <li>Етичні, соціальні та суспільні виклики, пов’язані з впровадженням AI — відповідальне використання технологій, вплив на суспільство та регуляторні аспекти.</li>
                        <li>Реальні бізнес-кейси та рекомендації для компаній і команд — приклади впровадження AI, практичні поради та lessons learned.</li>
                    </ul>

                    {/* Додана кнопка реєстрації */}

                </div>

            </div>
            <div className="about__btn__container">
                <a href="https://forms.gle/cfokNkvikAsoPaRA6" target="_blank" rel="noopener noreferrer">
                    <button className='about__reg__btn'>
                        Зареєструватися на подію
                    </button>
                </a>
            </div>
        </section>
    )
}

export default About